@let image = item().image;
@if (image && !error()) {
  <div class="relative" [style.width.px]="width()" [style.height.px]="height()">
    <img
      alt="Item image"
      [ngSrc]="image"
      fill
      class="object-contain"
      (error)="error.set(true)"
    />
  </div>
} @else {
  <app-icons icon="tire-no-image" [width]="width()"/>
}
